import React from 'react';

const SetupTitleMini = (props) => {
    return (
        <div style={{ fontWeight: 600, fontSize: 14 }}>
            {props?.children}
        </div>
    );
}

export default SetupTitleMini;